module.exports = __webpack_public_path__ + "img/icon-ai-xiaojie@3x.54275cc1.png";